export const selectOptionsUwChecklistStatus = [
  "Requested",
  "Received",
  "Approved",
  "Rejected",
  "Pending",
  "Not Required",
];
